/**
 * Job Status Badge Component
 * Displays batch job execution status with appropriate colors
 */

import { cn } from '@/lib/utils'

interface JobStatusBadgeProps {
  status: string
}

export function JobStatusBadge({ status }: JobStatusBadgeProps) {
  const upper = status?.toUpperCase()

  if (upper === 'RUNNING') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-blue-50 px-2.5 py-1 text-sm font-medium text-blue-700">
        <span className="h-2 w-2 rounded-full bg-blue-500 animate-pulse" />
        Running
      </span>
    )
  }

  if (upper === 'SUCCESS') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-green-50 px-2.5 py-1 text-sm font-medium text-green-700">
        <span className="h-2 w-2 rounded-full bg-green-500" />
        Success
      </span>
    )
  }

  if (upper === 'FAILED') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2.5 py-1 text-sm font-medium text-red-700">
        <span className="h-2 w-2 rounded-full bg-red-500" />
        Failed
      </span>
    )
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full bg-gray-50 px-2.5 py-1 text-sm font-medium text-gray-700',
      )}
    >
      <span className="h-2 w-2 rounded-full bg-gray-400" />
      {status || 'Unknown'}
    </span>
  )
}
